import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import CustomTextEditor from "../../Components/Reusable/CustomTextEditor";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import DynamicService from "../../Services/DynamicService";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/authContext";
const AboutUs = () => {
  const [aboutUsData, setAboutUsData] = useState();
  const [resetValue, setResetValue] = useState(false);
  const {user}=useContext(AuthContext)

  const Validations = yup.object().shape({
    cardOneTitle: validationRegex.required,
    cardOneDescription: validationRegex.required,
    cardTwoTitle: validationRegex.required,
    cardTwoDescription: validationRegex.required,
    cardThreeTitle: validationRegex.required,
    cardThreeDescription: validationRegex.required,
    cardFourTitle: validationRegex.required,
    cardFourDescription: validationRegex.required,
  });

  const {
    register: register,
    handleSubmit: handleSubmit,
    setValue: setValues,
    formState: { errors: errors },
    getValues: getValues,
    reset: reset,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      cardOneTitle: aboutUsData?.cardOneTitle || "",
      cardOneDescription: aboutUsData?.cardOneDescription || "",
      cardTwoTitle: aboutUsData?.cardTwoTitle || "",
      cardTwoDescription: aboutUsData?.cardTwoDescription || "",
      cardThreeTitle: aboutUsData?.cardThreeTitle || "",
      cardThreeDescription: aboutUsData?.cardThreeDescription || "",
      cardFourTitle: aboutUsData?.cardFourTitle || "",
      cardFourDescription: aboutUsData?.cardFourDescription || "",
    },
  });

  useEffect(() => {
    getAboutUsData();
  }, []);

  const onSubmit = async (data) => {

    const dynamicPrivilege = user?.setPrivileges?.find(
      (priv) => priv.parameter === "Dynamic"
    );

    if (dynamicPrivilege?.update) {

    try {
      // Call DynamicService to add the cancellationPolicyData
      await DynamicService.addAboutUsData(data);
      toast.success("Data Updated Successfully!");
      //   navigate(RoutesPath.viewBlog);
    } catch (error) {
      handleApiErrors(error);
    }
  }else{
    toast.warning("You don't have permission to update about us.");
  }
  };

  const getAboutUsData = async () => {
    try {
      const response = await DynamicService.getAboutUsPageContent();
      const data = response.data;
      setAboutUsData(data);
      setValues("cardOneTitle", data.cardOneTitle);
      setValues("cardOneDescription", data.cardOneDescription);
      setValues("cardTwoTitle", data.cardTwoTitle);
      setValues("cardTwoDescription", data.cardTwoDescription);
      setValues("cardThreeTitle", data.cardThreeTitle);
      setValues("cardThreeDescription", data.cardThreeDescription);
      setValues("cardFourTitle", data.cardFourTitle)
      setValues("cardFourDescription", data.cardFourDescription);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0"> ABOUT US PAGE </h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0"> About Us Page</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">About Us Page</h1>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row profile_inputs w-100 mt-4">
              <div className="">
                <CustomTextField
                  labelTitle="Title"
                  placeholder="File Name"
                  name="cardOneTitle"
                  id="cardOneTitle"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.cardOneTitle}
                  errorMessage={errors?.cardOneTitle?.message}
                />
              </div>
              <div>
                <CustomTextEditor
                  labelTitle={"section 1"}
                  name="cardOneDescription"
                  id="cardOneDescription"
                  resetValue={resetValue}
                  setValue={setValues}
                  setResetValue={setResetValue}
                  showError={errors}
                  errorMessage={errors?.cardOneDescription?.message}
                  showMandatory={true}
                  defaultValue={aboutUsData?.cardOneDescription || ""}
                />
              </div>
            </div>
            <div className="row profile_inputs w-100 mt-4">
              <div className="">
                <CustomTextField
                  labelTitle="Title"
                  placeholder="File Name"
                  name="cardTwoTitle"
                  id="cardTwoTitle"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.cardTwoTitle}
                  errorMessage={errors?.cardTwoTitle?.message}
                />
              </div>
              <div>
                <CustomTextEditor
                  labelTitle={"section 2"}
                  name="cardTwoDescription"
                  id="cardTwoDescription"
                  resetValue={resetValue}
                  setValue={setValues}
                  setResetValue={setResetValue}
                  showError={errors}
                  errorMessage={errors?.cardTwoDescription?.message}
                  showMandatory={true}
                  defaultValue={aboutUsData?.cardTwoDescription || ""}
                />
              </div>
            </div>
            <div className="row profile_inputs w-100 mt-4">
              <div className="">
                <CustomTextField
                  labelTitle="Title"
                  placeholder="File Name"
                  name="cardThreeTitle"
                  id="cardThreeTitle"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.cardThreeTitle}
                  errorMessage={errors?.cardThreeTitle?.message}
                />
              </div>
              <div>
                <CustomTextEditor
                  labelTitle={"section 3"}
                  name="cardThreeDescription"
                  id="cardThreeDescription"
                  resetValue={resetValue}
                  setValue={setValues}
                  setResetValue={setResetValue}
                  showError={errors}
                  errorMessage={errors?.cardThreeDescription?.message}
                  showMandatory={true}
                  defaultValue={aboutUsData?.cardThreeDescription || ""}
                />
              </div>
            </div>
            <div className="row profile_inputs w-100 mt-4">
              <div className="">
                <CustomTextField
                  labelTitle="Title"
                  placeholder="File Name"
                  name="cardFourTitle"
                  id="cardFourTitle"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.cardFourTitle}
                  errorMessage={errors?.cardFourTitle?.message}
                />
              </div>
              <div>
                <CustomTextEditor
                  labelTitle={"section 4"}
                  name="cardFourDescription"
                  id="cardFourDescription"
                  resetValue={resetValue}
                  setValue={setValues}
                  setResetValue={setResetValue}
                  showError={errors}
                  errorMessage={errors?.cardFourDescription?.message}
                  showMandatory={true}
                  defaultValue={aboutUsData?.cardFourDescription || ""}
                />
              </div>
              <div className="d-flex justify-content-end mt-3">
                <ButtonWithIcon
                  text={"Submit"}
                  icon={SvgImages.tick_mark}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
